module.exports = __webpack_public_path__ + "af63073c.svg";